import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { clearState } from '../../app/store/clear-state.reducer';
import { NewItineraryValidationService } from '../../pages/new-itinerary/new-itinerary-validation.service';
import { OrganizationRiderEffects } from './organization-rider.effects';
import { initialState, organizationRiderReducer } from './organization-rider.reducer';
import { CacheService } from '@uzurv/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
  imports: [
    CommonModule,
    MatSnackBarModule,
    StoreModule.forFeature('organizationRider', organizationRiderReducer, { initialState: initialState, metaReducers: [clearState] }),
    EffectsModule.forFeature([OrganizationRiderEffects])
  ],
  providers: [OrganizationRiderEffects, NewItineraryValidationService, CacheService]
})
export class OrganizationRiderStoreModule {}
